import { Component } from '@angular/core';
import { Feature } from '@freelancer/feature-flags';
import { ButtonColor } from '@freelancer/ui/button';
@Component({
  selector: 'app-navigation-secondary-about',
  template: `
    <app-bar
      i18n-appBarTitle="Secondary navigation about us bar title"
      appBarTitle="About Us"
      link="/about"
      flTrackingSection="SubnavAbout"
    >
      <app-bar-item
        link="/about"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Overview"
        [exactLink]="true"
      >
        Overview
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.ABOUT_FLNLTD_PAGES"
        link="/about/management"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Team"
        [exactLink]="true"
      >
        Team
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.ABOUT_FLNLTD_PAGES"
        link="/careers"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Careers"
        [exactLink]="true"
      >
        Careers
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.ABOUT_FLNLTD_PAGES"
        i18n="Secondary navigation about us bar item"
        link="/about/press"
        flTrackingLabel="Press"
        [exactLink]="true"
      >
        Press
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.ABOUT_FLNLTD_PAGES"
        i18n="Secondary navigation about us bar item"
        link="/about/media"
        flTrackingLabel="News"
        [exactLink]="true"
      >
        News
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.ABOUT_FLNLTD_PAGES"
        link="/about/awards"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Awards"
        [exactLink]="true"
      >
        Awards
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.ABOUT_FLNLTD_PAGES"
        link="/about/quotes"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Quotes"
        [exactLink]="true"
      >
        Quotes
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.ABOUT_FLNLTD_PAGES"
        link="/investor"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Investor"
        [exactLink]="true"
      >
        Investor
      </app-bar-item>
      <app-bar-item
        link="/about/security"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="Security"
        [exactLink]="true"
      >
        Security
      </app-bar-item>
      <app-bar-item
        link="/contact"
        i18n="Secondary navigation about us bar item"
        flTrackingLabel="ContactUs"
        [exactLink]="true"
      >
        Contact Us
      </app-bar-item>
    </app-bar>
  `,
})
export class NavigationSecondaryAboutComponent {
  ButtonColor = ButtonColor;
  Feature = Feature;
}
